/**
 * Homepage reveal on scroll. layout/theme.liquid adds .reveal-ready to <html>
 * before first paint (homepage only, and not for reduced motion), which hides
 * the targets in section-home-revamp.css; this marks each one .is-revealed as
 * it scrolls into view. Items that share a parent arrive one after another.
 */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('reveal-ready')) return;

  var targets = document.querySelectorAll(root.getAttribute('data-reveal-targets'));
  if (!('IntersectionObserver' in window)) {
    root.classList.remove('reveal-ready');
    return;
  }

  // Stagger siblings: 90ms apart, capped so long rows don't lag.
  var seen = new Map();
  targets.forEach(function (el) {
    var parent = el.parentElement;
    var index = seen.get(parent) || 0;
    seen.set(parent, index + 1);
    el.style.setProperty('--reveal-delay', Math.min(index, 5) * 90 + 'ms');
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  targets.forEach(function (el) { observer.observe(el); });
  root.setAttribute('data-reveal-started', '');
})();
